import React, {
    useState,
    useEffect,
    useRef
} from "react";

import "../css/Navbar.css";

import ScrollButton from "./ScrollButton";

function Navbar() {

    /*==========================================
        ESTADOS
    ==========================================*/

    const [menuOpen, setMenuOpen] = useState(false);

    const [conocenosOpen, setConocenosOpen] = useState(false);

    const [galeriaOpen, setGaleriaOpen] = useState(false);

    const [navbarFixed, setNavbarFixed] = useState(false);

    const navbarRef = useRef(null);

    /*==========================================
        ABRIR / CERRAR MENÚ
    ==========================================*/

    const toggleMenu = () => {

        setMenuOpen(!menuOpen);

    };

    const toggleConocenos = (e) => {

        e.preventDefault();

        setConocenosOpen(!conocenosOpen);

    };

    const toggleGaleria = (e) => {

        e.preventDefault();

        setGaleriaOpen(!galeriaOpen);

    };

    const closeMenu = () => {

        setMenuOpen(false);

        setConocenosOpen(false);

        setGaleriaOpen(false);

    };

    /*==========================================
        BOTÓN INICIO
    ==========================================*/

    const goTop = (e) => {

        e.preventDefault();

        window.scrollTo({

            top: 0,

            behavior: "smooth"

        });

        closeMenu();

    };

    /*==========================================
        SCROLL SUAVE
    ==========================================*/

    const goSection = (e, id) => {

        e.preventDefault();

        const element = document.getElementById(id);

        if (element) {

            const offset = 95;

            const position =
                element.getBoundingClientRect().top +
                window.pageYOffset -
                offset;

            window.scrollTo({

                top: position,

                behavior: "smooth"

            });

        }

        closeMenu();

    };

    /*==========================================
        CLICK FUERA DEL MENÚ
    ==========================================*/

    useEffect(() => {

        const handleClickOutside = (event) => {

            if (

                navbarRef.current &&
                !navbarRef.current.contains(event.target)

            ) {

                closeMenu();

            }

        };

        document.addEventListener(

            "click",

            handleClickOutside

        );

        return () => {

            document.removeEventListener(

                "click",

                handleClickOutside

            );

        };

    }, []);

    /*==========================================
        NAVBAR STICKY
    ==========================================*/

    useEffect(() => {

        const handleScroll = () => {

            if (window.scrollY > 120) {

                setNavbarFixed(true);

            }

            else {

                setNavbarFixed(false);

            }

        };

        window.addEventListener(

            "scroll",

            handleScroll

        );

        return () => {

            window.removeEventListener(

                "scroll",

                handleScroll

            );

        };

    }, []);

        return (

        <nav
            className={`esc-navbar ${menuOpen ? "esc-open" : ""} ${navbarFixed ? "esc-navbar-fixed" : ""}`}
            ref={navbarRef}
        >

            <div className="esc-navbar-logo">
                {/* Logo opcional */}
            </div>

            <div
                className="esc-navbar-toggle"
                onClick={toggleMenu}
            >

                <div className="esc-navbar-bar"></div>
                <div className="esc-navbar-bar"></div>
                <div className="esc-navbar-bar"></div>

            </div>

            <ul
                className={`esc-navbar-menu ${menuOpen ? "esc-open" : ""}`}
            >

                <li>

                    <a
                        href="/"
                        onClick={goTop}
                    >

                        Inicio

                    </a>

                </li>

                <li>

                    <a
                        href="#events-component"
                        onClick={(e) =>
                            goSection(
                                e,
                                "events-component"
                            )
                        }
                    >

                        Informaciones

                    </a>

                </li>

                <li
                    className={`esc-navbar-dropdown ${conocenosOpen ? "esc-open" : ""}`}
                >

                    <a
                        href="/"
                        onClick={toggleConocenos}
                    >

                        Conócenos

                    </a>

                    <ul
                        className={`esc-navbar-submenu ${conocenosOpen ? "esc-open" : ""}`}
                    >

                        <li>

                            <a
                                href="#QuienesSomos"
                                onClick={(e) => goSection(e, "QuienesSomos")}
                            >

                                Quiénes Somos

                            </a>

                        </li>

                        <li>

                            <a
                                href="#personal-establecimiento"
                                onClick={(e) => goSection(e, "personal-establecimiento")}
                            >

                                Personal del Establecimiento

                            </a>

                        </li>

                        <li>

                            <a
                                href="#nuestra-mision-component"
                                onClick={(e) => goSection(e, "nuestra-mision-component")}
                            >

                                Nuestra Misión

                            </a>

                        </li>

                        <li>

                            <a
                                href="#vision-component"
                                onClick={(e) => goSection(e, "vision-component")}
                            >

                                Visión

                            </a>

                        </li>

                        <li>

                            <a
                                href="#sellos-component"
                                onClick={(e) => goSection(e, "sellos-component")}
                            >

                                Sellos

                            </a>

                        </li>

                        <li>

                            <a
                                href="#valores-component"
                                onClick={(e) => goSection(e, "valores-component")}
                            >

                                Valores

                            </a>

                        </li>

                    </ul>

                </li>

                <li
                    className={`esc-navbar-dropdown ${galeriaOpen ? "esc-open" : ""}`}
                >

                    <a
                        href="/"
                        onClick={toggleGaleria}
                    >

                        Galerías & Trabajos

                    </a>

                    <ul
                        className={`esc-navbar-submenu ${galeriaOpen ? "esc-open" : ""}`}
                    >

                        <li><a href="#cuadrohonor-component" onClick={(e) => goSection(e, "cuadrohonor-component")}>Cuadro de Honor</a></li>

                        <li><a href="#licenciados-component" onClick={(e) => goSection(e, "licenciados-component")}>Licenciados & Graduados</a></li>

                        <li><a href="#videos-container" onClick={(e) => goSection(e, "videos-container")}>Galería Audiovisual</a></li>

                        <li><a href="#Instagram-list" onClick={(e) => goSection(e, "Instagram-list")}>Galería Instagram</a></li>

                        <li>

                            <a
                                href="https://padlet.com/g4pzjdvh65/talleres-jec-de-artes-dggvfttlwwonztsd"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={closeMenu}
                            >

                                Galería de Arte

                            </a>

                        </li>

                        <li><a href="#biblioteca-cra-component" onClick={(e) => goSection(e, "biblioteca-cra-component")}>Biblioteca CRA</a></li>

                         <li>

                    <a
                        href="#centro-innovacion-component"
                        onClick={(e) => goSection(e, "centro-innovacion-component")}
                    >

                        Centro de Innovación

                    </a>

                   </li>






                    </ul>

                </li>

               

                <li>

                    <a
                        href="#documentos"
                        onClick={(e) => goSection(e, "documentos")}
                    >

                        Documentos Institucionales

                    </a>

                </li>

                <li>

                    <a
                        href="#Listajunaeb"
                        onClick={(e) => goSection(e, "Listajunaeb")}
                    >

                        Alimentación Junaeb

                    </a>

                </li>

                <li>

                    <a
                        href="#listacursos"
                        onClick={(e) => goSection(e, "listacursos")}
                    >

                        Útiles Escolares 2026

                    </a>

                </li>

                <li>

                    <a
                        href="#contacto"
                        onClick={(e) => goSection(e, "contacto")}
                    >

                        Contacto    

                    </a>

                </li>

                <ScrollButton direction="top" />

                <ScrollButton direction="bottom" />

            </ul>

        </nav>

    );

}

export default Navbar;